import { useEffect } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { Label, SegmentedControl } from "@osago/ui";
import type { SegmentedOption } from "@osago/ui";
import logoUrl from "@/assets/logo.jpg";
import { NAV_ITEMS } from "./routes";

const NAV_OPTIONS: SegmentedOption<string>[] = NAV_ITEMS.map((item) => ({
  value: item.to,
  label: item.label,
}));

export function AppHeader() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const active = NAV_ITEMS.find((item) => matchPath(item.to, pathname)) ?? NAV_ITEMS[0];

  useEffect(() => {
    document.title = active.title;
  }, [active.title]);

  return (
    <header className="border-b border-input-border bg-card">
      <div className="mx-auto flex max-w-350 flex-wrap items-center gap-3 px-6 py-4">
        <img src={logoUrl} alt="ОСАГО.top" className="h-8 w-auto" />
        <span className="h-5 w-px flex-none bg-input-border" />
        <div className="flex flex-col gap-0.5">
          <Label variant="section" as="h1">
            {active.title}
          </Label>
          <Label variant="caption">{active.caption}</Label>
        </div>
        <nav className="ml-auto">
          <SegmentedControl
            options={NAV_OPTIONS}
            value={active.to}
            // query переносим на соседнюю вкладку: affid и прочие партнёрские
            // параметры должны оставаться в адресной строке
            onChange={(to) => navigate(to + search)}
          />
        </nav>
      </div>
    </header>
  );
}
